
import { defineComponent, PropType } from "vue";
import { ISlide } from "@/models/slide";
import { BFF_BASE_PATH } from "@/core/utils"

export default defineComponent({
  computed: {
    imageSrc (): string {
      return `${BFF_BASE_PATH}/slide/${encodeURIComponent(this.slide.slideId)}/${this.path}`
    }
  },
  props: {
    slide: {
      type: Object as PropType<ISlide>,
      required: true,
    },
    path: {
      type: String,
      default: '',
    }
  }
})
